import { initSelectForm } from './form.js';
import { initStageVideos } from './list.js';

export function initAssignVideo() {
	initSelectForm();
	initStageVideos();
}
